// The Vue build version to load with the import command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import App from './App'
import router from './router'
// import '@/permission' // permission control

// ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-TW' // lang i18n

// datepicker
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

// Multiselect
import Multiselect from 'vue-multiselect'

// Bootstrap
// import 'bootstrap/dist/css/bootstrap.css'
// import * as bootstrap from "bootstrap/dist/js/bootstrap.js"
import Popper from 'popper.js'

// fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(DatePicker)
Vue.use(ElementUI, { locale }, Popper)

Vue.component('multiselect', Multiselect)

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
